class AppConstants {
    static BOSSUPINDUSTRYID: string = '-MsUOGcOT9oRXGakCcJv';
    static LEARNINGID = '-Mos1VMnV53H7AZa0W8p';
    static OPPORTUNITIESID = '-Mos1VMnV53H7AZa0W8q';
    static BOSS_UP_CHALLENGE_CATEGORY_ID = '-Mos1VMlx3oxZFRaw_BH';
}


export default AppConstants